module.exports = __webpack_public_path__ + "img/cc.88966b4e.svg";